<div *ngIf="issue && update" style="margin-bottom: 10px;">
    <p>[{{issueType}}] {{issue.summary}}</p>
    <p>{{issue.description}}</p>

    <p>New Status: {{ update.status }}</p>

    <button (click)="acceptUpdate()" class="pb-button" mat-raised-button>
        Accept
    </button>
    <button (click)="rejectUpdate()" class="pb-button" mat-raised-button>
        Reject
    </button>
</div>